import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { BrandingModule } from '@feature/branding';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import {
  UIButtonModule,
  UICurrencyModule,
  UIDialogModule,
  UIIconModule,
  UIPoweredByCarepayModule,
  UISpinnerModule,
  UIStatusLabelModule,
} from '@ui/components';
import { SharedCardFinancialsComponent } from './components/card/card-financials/card-financials.component';
import { SharedCardComponent } from './components/card/card/card.component';
import { SharedFullScreenErrorNetworkComponent } from './components/full-screen-error-network/full-screen-error-network.component';
import { SharedFullScreenErrorUnknownComponent } from './components/full-screen-error-unknown/full-screen-error-unknown.component';
import { SharedFullScreenLoaderWithErrorComponent } from './components/full-screen-loader-with-error/full-screen-loader-with-error.component';
import { SharedFullScreenRefresherComponent } from './components/full-screen-refresher/full-screen-refresher.component';
import { SharedFullScreenComponent } from './components/full-screen/full-screen.component';
import { SharedRootedDeviceDialogComponent } from './components/rooted-device-dialog/rooted-device-dialog.component';
import { SharedFullNamePipe } from './pipes/full-name/full-name.pipe';
import { SharedProductNamePipe } from './pipes/product-name/product-name.pipe';
import { SharedStatusColorPipe } from './pipes/status/status-color.pipe';
import { SharedStatusMapPipe } from './pipes/status/status-map.pipe';

@NgModule({
  declarations: [
    SharedStatusColorPipe,
    SharedFullScreenComponent,
    SharedFullNamePipe,
    SharedStatusMapPipe,
    SharedProductNamePipe,
    SharedCardComponent,
    SharedCardFinancialsComponent,
    SharedFullScreenErrorUnknownComponent,
    SharedFullScreenErrorNetworkComponent,
    SharedFullScreenRefresherComponent,
    SharedFullScreenLoaderWithErrorComponent,
    SharedRootedDeviceDialogComponent,
  ],
  imports: [
    CommonModule,
    UIStatusLabelModule,
    RouterModule,
    UICurrencyModule,
    UIIconModule,
    UIButtonModule,
    IonicModule,
    UISpinnerModule,
    UIPoweredByCarepayModule,
    BrandingModule,
    MatDialogModule,
    UIDialogModule,
    TranslateModule,
  ],
  exports: [
    SharedStatusColorPipe,
    SharedFullScreenComponent,
    SharedFullNamePipe,
    SharedStatusMapPipe,
    SharedProductNamePipe,
    SharedCardComponent,
    SharedCardFinancialsComponent,
    SharedFullScreenErrorUnknownComponent,
    SharedFullScreenErrorNetworkComponent,
    SharedFullScreenRefresherComponent,
    SharedFullScreenLoaderWithErrorComponent,
  ],
})
export class SharedModule {}
